import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section background="cream-dark" className="border-t border-brand-gold/10" data-id="element-79">
      <div className="max-w-3xl mx-auto text-center" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-81">
          <div className="mb-8 flex justify-center" data-id="element-82">
            <div className="h-1 w-20 bg-brand-gold rounded-full" data-id="element-83"></div>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif italic text-brand-charcoal-dark mb-8 leading-relaxed" data-id="element-84">
            "Son las 3 de la tarde. Tienes 40 pestañas abiertas en el navegador,
            12 mensajes sin leer y una presión sorda en el pecho que no te deja
            pensar."
          </h2>

          <p className="text-lg text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-85">
            Sabes lo que tienes que hacer, pero tu cerebro simplemente...{' '}
            <span className="font-bold text-brand-charcoal-dark" data-id="element-86">
              no arranca.
            </span>
          </p>

          <div className="bg-white p-5 sm:p-8 rounded-lg shadow-sm border border-brand-gold/20 text-left relative overflow-hidden" data-id="element-87">
            <div className="absolute top-0 left-0 w-1 h-full bg-brand-gold" data-id="element-88"></div>
            <div className="flex items-start gap-3 sm:gap-4" data-id="element-89">
              <AlertCircle className="h-5 w-5 sm:h-6 sm:w-6 text-brand-gold-dark flex-shrink-0 mt-1" data-id="element-90" />
              <div data-id="element-91">
                <h3 className="text-lg sm:text-xl font-bold text-brand-charcoal-dark mb-2" data-id="element-92">
                  Lo llaman "Bloqueo". La ciencia lo llama Toxicidad por
                  Cortisol.
                </h3>
                <p className="text-sm sm:text-base text-brand-charcoal/70" data-id="element-93">
                  Estás operando en modo supervivencia. Y en ese modo, nadie
                  toma buenas decisiones. Nadie escala negocios. Nadie es feliz.
                  Tu cuerpo está gritando "peligro" cuando solo estás intentando
                  responder un email.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}